/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Bundle Thunk
 */

import type { BuildingListingCollection, Bundle } from '@zcode/bizos'
import { isCommonAuthError } from '@zcode/error-filters'
import { EVENT_NAMES, track } from '@zcode/mixpanel'
import { AnalyticsC, localStorageSingleton, trackGAEvent } from '@zcode/nr-utils'
import * as Api from '@zcode/nr/es/shared/api'
import type { Dispatch } from 'redux'
import { logger } from '../logger'
import type { GetState } from '../modules/types'
import { addSuccessButterBar } from './butter.action'
import { convertLocalFavorites, setBundle } from './index'

/**
 * helper function for login and signup functions
 */
export const loginHandler =
  (bundle: Bundle & { user: NonNullable<Bundle['user']> }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const localFavorites: BuildingListingCollection | null | undefined =
      localStorageSingleton.get('favorites')
    // show success butter bar
    dispatch(addSuccessButterBar({ message: `Welcome, ${bundle.user.firstName}!` }))
    dispatch(setBundle(bundle))
    // combining server bundle favorites + local favorites
    dispatch(convertLocalFavorites(localFavorites))

    // try to push all the locally favorited listing/buildings to svr
    // convert localStorage favorites to server
    if (
      localFavorites &&
      (Object.keys(localFavorites.buildings).length || Object.keys(localFavorites.listings).length)
    ) {
      try {
        const buildingIds = Object.keys(localFavorites.buildings).map(Number)
        const listingIds = Object.keys(localFavorites.listings).map(Number)
        // triggering bulk favorite
        Api.favorites.add({ buildingIds, listingIds }).then((result) => {
          if (result.success) {
            // successfully pushed all the locally favorited listings/buildings to server, remove it from
            // localStorage
            localStorageSingleton.del('favorites')
          }
        })
      } catch (e) {
        if (!isCommonAuthError(e)) {
          logger.error('error while saving local favorites', e)
        }
      }
    }
  }

export const logout = (origin?: string) => {
  trackGAEvent(AnalyticsC.LOGIN, 'Log Out success', origin)
  track({ event: EVENT_NAMES.SIGN_OUT })
}
